export interface Sector {
  id: string
  nameKey: string
}

export const SECTORS: Sector[] = [
  { id: 'energy_environment', nameKey: 'sector.energyEnvironment' },
  { id: 'finance_insurance', nameKey: 'sector.financeInsurance' },
  { id: 'technology_digital', nameKey: 'sector.technologyDigital' },
  { id: 'food_agriculture', nameKey: 'sector.foodAgriculture' },
  { id: 'healthcare_life_sciences', nameKey: 'sector.healthcareLifeSciences' },
  {
    id: 'infrastructure_real_estate',
    nameKey: 'sector.infrastructureRealEstate',
  },
  { id: 'manufacturing_industry', nameKey: 'sector.manufacturingIndustry' },
  { id: 'consulting_services', nameKey: 'sector.consultingServices' },
  { id: 'public_sector_policy', nameKey: 'sector.publicSectorPolicy' },
  { id: 'education_research', nameKey: 'sector.educationResearch' },
  { id: 'nonprofit_ngos', nameKey: 'sector.nonprofitNgos' },
  { id: 'transport_logistics', nameKey: 'sector.transportLogistics' },
  { id: 'media_communications', nameKey: 'sector.mediaCommunications' },
  { id: 'other', nameKey: 'sector.other' },
]
